import { ChipProps } from '@sato/components';

import { MessageStatus } from '@models/Incident';
import { TranslatorFn } from '@stores/localization';

const chipClasses = {
  open: 'bg-white text-black-text border border-black-light',
  onHold: 'bg-brand-primary-light text-black-text',
  success: 'bg-brand-tertiary-light text-black-text',
  error: 'bg-brand-text-error text-white-text',
} as const;

export const getMessageStatusChipProps = (
  statusCode: MessageStatus,
  t: TranslatorFn
): ChipProps | undefined => {
  switch (statusCode) {
    case MessageStatus.OPEN:
      return {
        variant: 'filled',
        className: chipClasses.open,
        children: t('incident_open'),
      };
    case MessageStatus.IN_PROGRESS:
      return {
        variant: 'filled',
        className: chipClasses.open,
        children: t('incident_in_progress'),
      };
    case MessageStatus.WAITING_FOR_DETAILS:
      return {
        variant: 'filled',
        className: chipClasses.onHold,
        children: t('incident_waiting_for_details'),
      };
    case MessageStatus.WAITING_FOR_PARTNER:
      return {
        variant: 'filled',
        className: chipClasses.onHold,
        children: t('incident_being_processed'),
      };
    case MessageStatus.GIVEN_INFORMATION:
    case MessageStatus.COMPLETED:
      return {
        variant: 'filled',
        /** TODO: turquoise background color */
        className: chipClasses.success,
        children: t('incident_solved'),
      };
    case MessageStatus.REJECTED:
      return {
        variant: 'filled',
        className: chipClasses.error,
        children: t('incident_cancelled'),
      };
    // TODO: What do Combined or On Hold mean? Check their usecase and translations
    case MessageStatus.ONHOLD:
      return {
        variant: 'filled',
        className: chipClasses.onHold,
        children: t('incident_on_hold'),
      };
    case MessageStatus.COMBINED:
      return undefined;
  }
};
